import { render, staticRenderFns } from "./fragment-gfx-form.vue?vue&type=template&id=be71c030&scoped=true&"
import script from "./fragment-gfx-form.vue?vue&type=script&lang=js&"
export * from "./fragment-gfx-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be71c030",
  null
  
)

export default component.exports